/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Cup_DateInputs */

const en_last_cup_date = /** @type {(inputs: Last_Cup_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Cup Date`)
};

const es_last_cup_date = /** @type {(inputs: Last_Cup_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima fecha de catacion`)
};

/**
* | output |
* | --- |
* | "Last Cup Date" |
*
* @param {Last_Cup_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const last_cup_date = /** @type {((inputs?: Last_Cup_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Cup_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_last_cup_date(inputs)
	return es_last_cup_date(inputs)
});